const safeText = (value) => {
  const text = String(value || "");
  return /^[=+\-@\t\r]/.test(text) ? `'${text}` : text;
};
// These exports deliberately contain only the lightweight opening snapshot.
// Full custom answers and ticket lines are exported by the server worker.
export function participantCsvRows(participants) {
  return participants.map((person) => ({
    id: person.id,
    Firstname: person.firstName || "",
    Name: person.lastName || "",
    Email: person.email || "",
    createdAt: person.creationDate ? new Date(person.creationDate).toISOString() : "",
    isRead: Boolean(person.isRead),
    numberOfScan: Number(person.numberOfScan || 0),
    quantity: Number(person.quantity || 0),
  }));
}
export function recipientCsvRows(participants) {
  const recipients = new Map();
  participants.forEach((person) => {
    const email = String(person.email || "")
      .trim()
      .toLowerCase();
    if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) && !recipients.has(email))
      recipients.set(email, {
        email,
        name: [person.firstName, person.lastName].filter(Boolean).join(" "),
      });
  });
  return [...recipients.values()];
}

export function localCsvText(rows, headers) {
  const quote = (value) => `"${safeText(value == null ? "" : String(value)).replace(/"/g, '""')}"`;
  return (
    "\uFEFF" +
    [
      headers.map(quote).join(";"),
      ...rows.map((row) => headers.map((key) => quote(row[key])).join(";")),
    ].join("\r\n") +
    "\r\n"
  );
}
export function downloadLocalCsv(rows, headers, filename) {
  const blob = new Blob([localCsvText(rows, headers)], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob),
    link = document.createElement("a");
  try {
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
  } finally {
    link.remove();
    // Let mobile browsers consume the download before releasing its Blob URL.
    window.setTimeout(() => URL.revokeObjectURL(url), 60000);
  }
}
